import { createSlice } from "@reduxjs/toolkit";
import { 
  getEsignFlow, 
  createEsignFlow, 
  updateEsignFlow, 
  deleteEsignFlow,
  clearLocalActiveEsignFlow 
} from "./actions";

export const initialState = {
  esignFlow: { 
    id: '', 
    email: '', 
    context: '', 
    updated_at: '' 
  },
  loading: false
};

const slice = createSlice({
  name: 'esignFlows',
  initialState,
  reducers: {
    clearLocalActiveEsignFlow: (state) => {
      state.esignFlow = initialState.esignFlow;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getEsignFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEsignFlow.fulfilled, (state, action) => {
        const { esign_flow } = action.payload;
        const esignFlow = { ...state.esignFlow, ...esign_flow };
        
        state.loading = false;
        state.esignFlow = esignFlow;
      })
      .addCase(getEsignFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createEsignFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createEsignFlow.fulfilled, (state, action) => {
        const { esign_flow } = action.payload;

        state.loading = false;
        state.esignFlow = esign_flow;      
      })
      .addCase(createEsignFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateEsignFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateEsignFlow.fulfilled, (state, action) => {
        const { status, esign_flow } = action.payload;
        const updatedEsignFlow = { ...state.esignFlow, ...esign_flow };
        
        state.loading = false;
        if (status === 204) state.esignFlow = updatedEsignFlow;      
      })
      .addCase(updateEsignFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteEsignFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteEsignFlow.fulfilled, (state, action) => {
        const { status } = action.payload;
        
        state.loading = false;
        if (status === 204) state.esignFlow = initialState.esignFlow;    
      })
      .addCase(deleteEsignFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveEsignFlow, state => {
        state.esignFlow = initialState.esignFlow;
      })
  }
})

export default slice.reducer;